import { API } from "aws-amplify";
import * as queries from "../graphql/querries";
import * as mutations from "../graphql/mutations";
import { callGraphQL } from "../graphql/genericGraphqlFunction";

export const listEvents = async () =>
	await callGraphQL("listEventsForSponsor", queries.listEventsForSponsor());

export const downloadLeads = async (sponsor_code, event_id) =>
	await callGraphQL("downloadSponsorLeads", queries.downloadSponsorLeads(sponsor_code, event_id), {
		sponsorCode: sponsor_code,
		eventId: event_id
	});

export const getEventDetailsBySponsorCode = async (sponsor_code) =>
	await callGraphQL("getEventDetailsBySponsorCode", queries.getEventDetailsBySponsorCode(sponsor_code), {
		sponsorCode: sponsor_code
	});

export const getSponsorLeads = async (sponsor_code, token) =>
	await callGraphQL("getSponsorLeads", queries.getSponsorLeads(sponsor_code, token), {
		sponsorCode: sponsor_code,
		nextToken: token
	});

export const addSponsorLead = async (leadData) =>
	await callGraphQL("addSponsorLead", mutations.addSponsorLead, { input: leadData });

export const updateSponsorLead = async (leadData) =>
	await callGraphQL("updateSponsorLead", mutations.updateSponsorLead, { input: leadData });

export const createUserSponsorMapping = async (eventData) =>
	await callGraphQL("createUserSponsorMapping", mutations.createUserSponsorMapping, { input: eventData });

export const listSponsorTeam = async (eventId, sponsorCode) =>
  await API.graphql({
    query: queries.listSponsorTeam(eventId, sponsorCode),
  });

// export const addSponsorLeadIndividual = async(leadData) => await API.graphql({
//     query: mutations.addSponsorLeadIndividuals,
//     variables: {input: leadData}
// });
